type DateFormatOptions = 'date' | 'dateTime' | 'time';

const dateFormatConfig: Record<DateFormatOptions, Intl.DateTimeFormatOptions> = {
    date: {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric'
    },
    dateTime: {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        hour12: false
    },
    time: {
        hour: '2-digit',
        minute: '2-digit',
        hour12: false
    }
};

const formatDate = (date: Date | string, format: DateFormatOptions): string => {
    const parsedDate = typeof date === 'string' ? new Date(date) : date;

    if (isNaN(parsedDate.getTime())) {
        return '';
    }

    const formatted = new Intl.DateTimeFormat('nl-NL', dateFormatConfig[format]).format(parsedDate);
    return format === 'dateTime' ? formatted.replace(',', '') : formatted;
};

export const formatToDate = (date: Date | string): string => formatDate(date, 'date');
export const formatToDateTime = (date: Date | string): string => formatDate(date, 'dateTime');
export const formatToTime = (date: Date | string): string => formatDate(date, 'time');
